import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NearbyState } from './nearby.state';
import { AppState } from '../app.state';

// Feature selector for the NearbyState
export const selectNearbyState = createFeatureSelector<AppState, NearbyState>('nearby');

// Selector for discount data
export const selectDiscountData = createSelector(
  selectNearbyState,
  (state: NearbyState) => state.discountData
);

// Selector for loading state
export const selectDiscountLoading = createSelector(
  selectNearbyState,
  (state: NearbyState) => state.loading
);

// Selector for error state
export const selectDiscountError = createSelector(
  selectNearbyState,
  (state: NearbyState) => state.error
);

